import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../toolkit/uicomponentcss';


export interface LoaderWrapperCSSStyle extends UIComponentCSSStyle
{
    getContentDivCSSStyle(): object;
    getMobileContentDivCSSStyle(): object;
}

export class LoaderWrapperCSSStyleImpl extends UIComponentCSSStyleImpl implements LoaderWrapperCSSStyle
{   
    private width: string;

    setChildComponentWidth(width: string)
    {
        this.width = width;
    }

    getWrapperCSSStyle(): object
    {
        return {
            display: "display", /* Hidden by default */
            position: "fixed", /* Stay in place */
            zIndex: 2000, /* Sit on top */
            left: 0,
            // bottom:'0',
            top: '0px',
            width: "100%", /* Full width */
            height: "100%", 
            overflow: "auto", /* Enable scroll if needed */
           
            // backgroundColor: this.getResources().getColor(Colors.color_4), /* Fallback color */
            backgroundColor: "rgba(0,0,0,0.4)" /* Black w/ opacity */
        };
    }

    getContentDivCSSStyle(): object
    {
        return {
            position: "relative",
            justifyContent:"center",
            margin: "auto",
            padding: 0,
            top:'30%',
            borderRadius: "8px",
            zIndex: 2001,
            overflow: "visible",
            width: this.width,
            left:"150px",
        
            marginBottom: "171px",
            animationName: "animatetop",
            animationDuration: "0.4s"
        };
    }

    getMobileContentDivCSSStyle(): object
    {
        return {
            position: "relative",
            justifyContent:"center",
            margin: "auto",
            padding: 0,
            top:'30%',
            borderRadius: "8px",
            zIndex: 2001,
            overflow: "visible",
            width: this.width,
            left:"0px",
        
            marginBottom: "171px",
            animationName: "animatetop",
            animationDuration: "0.4s"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/loaderwrappercss.tsx